import { request } from "@/interface/helper";

const str = "marketingFeedback";

export const marketingFeedback = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/feedback/list" }),
    detail: (data) => request({ data, method: "post", url: "/feedback/detail" }),
    edit: (data) => request({ data, method: "post", url: "/feedback/modify" }),
  },
};
